const callbackReducer = (name) => (state = null, action) => {
  switch (action.type) {
    case `${name}_CLEAR`: return null;
    case `${name}_SET`: return action.payload;
    default: return state;
  }
};

export default callbackReducer;
